import { observer } from 'mobx-react-lite';

import { Button, Hero } from '@cfm-media/pwa-ui-components';
import { LoadableStatus } from '../mobx-utils';
import { parseHtml } from '../core/utils';
import { useStore } from '../core/store';
import { useTranslation } from '../core/utils/translations';

import { Loader } from '../components/loader';

import { ContentWrapper } from '../components/content-wrapper';
import { PageWrapper } from '../components/page-wrapper';

export const Insurance = observer(() => {
  const { t } = useTranslation('insurance-page');

  const { BookingStore } = useStore();

  if (BookingStore?.booking?.status !== LoadableStatus.done) {
    return <Loader />;
  }

  return (
    <PageWrapper>
      <Hero
        image="public/assets/images/teasers/insurance.jpg"
        iconClass="icon-documents"
        headline="Versicherung zubuchen"
        overlay
      />

      <ContentWrapper>
        {parseHtml(t('body-text'))}

        <InsuranceButton booking={BookingStore?.booking?.data?.toJSON()} />
      </ContentWrapper>
    </PageWrapper>
  );
});

function InsuranceButton({ booking }) {
  const { t } = useTranslation('insurance-page');

  const agency = booking?.agency?.country;
  const customer = booking?.client?.country;

  const code = countries[customer || agency?.toUpperCase()] || 'DE';

  return (
    <Button
      variant="primary"
      className="!w-full my-8"
      title={t(`hm-link-text-de`)}
      link={t(`hm-link-${code.toLowerCase()}`)}
      target="_blank"
    />
  );
}

const countries = {
  DEUTSCHLAND: 'DE',
  OESTERREICH: 'AT',
  SCHWEIZ: 'CH',
};
